import i18n from 'i18next';
import * as yup from 'yup';
import userFormSchema from './userFormSchema';
import pilotFormSchema from './pilotFormSchema';

const clientEditionFormSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required(() => i18n.t('common.message.requiredField')),
  description: yup.string(),
  users: yup
    .array()
    .transform((value) => {
      const filteredValue = value;
      filteredValue.pop();
      return filteredValue;
    })
    .of(userFormSchema),
  irthConfig: yup
    .object()
    .shape({
      id: yup.number().default(null).nullable(),
      isActive: yup.bool().default(false),
      apiKey: yup
        .string()
        .trim()
        .required(() => i18n.t('common.message.requiredField')),
      apiUrl: yup
        .string()
        .trim()
        .required(() => i18n.t('common.message.requiredField')),
      clientTemplate: yup.string().trim().nullable(),
    })
    .default(null)
    .nullable(),
  pilots: yup
    .array()
    .transform((value) => {
      const filteredValue = value;
      filteredValue.pop();
      return filteredValue;
    })
    .of(pilotFormSchema),
});

export default clientEditionFormSchema;
